<!-- 项目文件 -->
<template>
    <div>
        <Header :Logo="logo" :Link="link" :TitleList="titleList" :Color="color" :img="bgImg"></Header>
        <div class="w100p overflow minw1200">
            <div class="w100p  bgf6 pt30 pb40">
                <div class="w1200 mauto  mb50">
                    <div class="textc mt20 mb20">
                        <p class="fs36 c333 disinblock posre">
                            <span class="border-bottom1">
                                驾校微信运营<span class="c1f8">4</span>大难题
                            </span>
                        </p>
                        <P class="fs18 c666 textc mt10">专业事交给专业人</P>
                    </div>
                    <div class="w100p overflow mt20 mb20">
                        <div class="w22p disinblock ml18 mr18 bgfff textc pt40 pb40">
                            <p><img class="w88 h88" src="../../public/img/img32.png"></p>
                            <p class="fs36 c333 disinblock posre lh24 pb15 w50p disinblock">
                                <span class="border-bottom1 c333 fs16 lh22">
                                文案/美术/策划 专项要求高
                                </span>
                            </p>
                        </div>

                        <div class="w22p disinblock ml18 mr18 bgfff textc pt40 pb40">
                            <P><img class="w88 h88" src="../../public/img/img33.png"></P>
                            <p class="fs36 c333 disinblock posre lh24 pb15 w50p disinblock">
                                <span class="border-bottom1 c333 fs16 lh22">
                                    人员成本高 需要专人维护
                                </span>
                            </p>
                        </div>

                        <div class="w22p disinblock ml18 mr18 bgfff textc pt40 pb40">
                            <p><img class="w88 h88" src="../../public/img/img34.png"></P>
                            <p class="fs36 c333 disinblock posre lh24 pb15 w50p disinblock">
                                <span class="border-bottom1 c333 fs16 lh22">
                                需要微功能 技术门槛高
                                </span>
                            </p>
                        </div>

                        <div class="w22p disinblock ml18 mr18 bgfff textc pt40 pb40">
                        <p><img class="w88 h88" src="../../public/img/img35.png"></P>
                            <p class="fs36 c333 disinblock posre lh24 pb15 w50p disinblock">
                                <span class="border-bottom1 c333 fs16 lh22">
                                    不懂驾培行业 专业要求高
                                </span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="w100p pb40">
                <div class="w1260 mauto pt20">
                    <div class="textc mt20 mb20">
                        <p class="fs36 c333 disinblock posre">
                            <span class="border-bottom1">
                                我们提供的服务
                            </span>
                        </p>
                        
                    </div>
                    <div class="textc border2 pt16 pb16">
                        <span class="fs20 c666 ml16 mr16 cursor" @click="activeIndex(0)" :class="{'active':index==0}">驾校微官网</span>
                        <span class="fs20 c666 ml16 mr16 cursor" @click="activeIndex(1)" :class="{'active':index==1}">微信服务号菜单</span>
                        <span class="fs20 c666 ml16 mr16 cursor" @click="activeIndex(2)" :class="{'active':index==2}">微信推送矩阵</span>
                    </div>
                    <div>
                        <transition name="plus-icon">
                            <div class="icon-plus pl16 pr16 pt40 overflow" v-if="index == 0">
                                <div class="floatl posre">
                                    <div class="overflow  w100p h100p posre  zindex999 zoom1 indexbg">
                                        <div class=" posre zindex1 w100p">
                                            <img class="imgauto" src="../../public/img/img25.png">
                                        </div>
                                        <transition name="fade22">
                                            <li class="h100p overflow alit flexc w100p posab left0 top0 zindex999" v-if="isActive1==index" v-for="(item,index) in imgList " :key="index">
                                                <img style="width: 85%;height: 80%;"  :src="item" alt="">
                                            </li>
                                        </transition>
                                    </div>
                                     
                                </div>
                                <div class="floatl pl40 w60p">
                                    <p class="fs30 c333 pt30 pb10">驾校微官网</p>
                                    <ul class="disblock w100p textc">
                                        <li class="disinblock bg138 h40 lh40 w80p mt35">
                                            可兼容iOS、android、WP等多种智能手机操作系统
                                        </li>
                                        <li class="disinblock bg139 h40 lh40 mt35 w80p">
                                            可便捷的与微信、微博等网络互动咨询平台链接
                                        </li>
                                        <li class="disinblock bg140 h40 lh40 mt35 w80p">
                                            可将驾校所需微功能融合，使用推广方便快捷
                                        </li>
                                        <li class="disinblock bg141 h40 lh40 mt35 w80p">
                                            多款模版随意选择，展现方式丰富
                                        </li>
                                        <li class="disinblock bg142 h40 lh40 mt35 w80p">
                                            面丰富，布局灵活，扩展性强
                                        </li>
                                        <li class="disinblock bg143 h40 lh40 mt35 w80p">
                                            访问便捷，安全，用户体验更佳
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </transition>
                        <transition name="plus-icon">
                            <div class="icon-plus  pl16 pr16 pt40 overflow" v-if="index == 1">
                               
                                <div class="floatl posre">
                                    <div class="overflow  w100p h100p posre  zindex999 zoom1 indexbg">
                                        <div class=" posre zindex1 w100p">
                                            <img class="imgauto" src="../../public/img/img25.png">
                                        </div>
                                        <transition name="fade22">
                                            <li class="h100p overflow alit flexc w100p posab left0 top0 zindex999" v-if="isActive2==index"
                                                v-for="(item,index) in imgList2 " :key="index">
                                                <img style="width: 85%;height: 80%;" :src="item" alt="">
                                            </li>
                                        </transition>
                                    </div>
                                
                                </div>
                              
                                <div class="floatl pl40 w60p">
                                    <p class="fs30 c333 pt30 pb10">微信服务号菜单</p>
                                    <ul class="disblock w100p textc">
                                        <li class="disinblock bg138 h40 lh40 w80p mt35">
                                            可兼容iOS、android、WP等多种智能手机操作系统
                                        </li>
                                        <li class="disinblock bg139 h40 lh40 mt35 w80p">
                                            可便捷的与微信、微博等网络互动咨询平台链接
                                        </li>
                                        <li class="disinblock bg140 h40 lh40 mt35 w80p">
                                            可将驾校所需微功能融合，使用推广方便快捷
                                        </li>
                                        <li class="disinblock bg141 h40 lh40 mt35 w80p">
                                            多款模版随意选择，展现方式丰富
                                        </li>
                                        <li class="disinblock bg142 h40 lh40 mt35 w80p">
                                            面丰富，布局灵活，扩展性强
                                        </li>
                                        <li class="disinblock bg143 h40 lh40 mt35 w80p">
                                            访问便捷，安全，用户体验更佳
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </transition>
                        <transition name="plus-icon">
                            <div class="icon-plus  pl16 pr16 pt40 overflow" v-if="index == 2">
                            <div class="floatl posre">
                                <div class="overflow  w100p h100p posre  zindex999 zoom1 indexbg">
                                    <div class=" posre zindex1 w100p">
                                        <img class="imgauto" src="../../public/img/img25.png">
                                    </div>
                                    <transition name="fade22">
                                        <li class="h100p overflow alit flexc w100p posab left0 top0 zindex999" v-if="isActive3==index"
                                            v-for="(item,index) in imgList3 " :key="index">
                                            <img style="width: 85%;height: 80%;" :src="item" alt="">
                                        </li>
                                    </transition>
                                </div>
                            
                            </div>
                            <div class="floatl pl40 w60p">
                                <p class="fs30 c333 pt30 pb10">微信推送矩阵</p>
                                <ul class="disblock w100p textc">
                                    <li class="disinblock bg138 h40 lh40 w80p mt35">
                                        可兼容iOS、android、WP等多种智能手机操作系统
                                    </li>
                                    <li class="disinblock bg139 h40 lh40 mt35 w80p">
                                        可便捷的与微信、微博等网络互动咨询平台链接
                                    </li>
                                    <li class="disinblock bg140 h40 lh40 mt35 w80p">
                                        可将驾校所需微功能融合，使用推广方便快捷
                                    </li>
                                    <li class="disinblock bg141 h40 lh40 mt35 w80p">
                                        多款模版随意选择，展现方式丰富
                                    </li>
                                    <li class="disinblock bg142 h40 lh40 mt35 w80p">
                                        面丰富，布局灵活，扩展性强
                                    </li>
                                    <li class="disinblock bg143 h40 lh40 mt35 w80p">
                                        访问便捷，安全，用户体验更佳
                                    </li>
                                </ul>
                            </div>
                            </div>
                        </transition>
                    </div>
                </div>
            </div>
            <div class="w100p pt15  pb40">
                <div class="textc mt20 mb20">
                    <p class="fs36 c333 disinblock posre">
                        <span class="border-bottom1">
                            为什么选择我们
                        </span>
                    </p>
                    <P class="fs18 c666 textc mt10">因为我们专业服务驾校</P>
                </div>
                <div class="w100p minh330 pt20 posre   bg40"  ref="lightBtn">
                    <!-- <div class="zindex1 posab top0 left0">
                        <img class="imgauto" src="../../public/img/img40.png">
                    </div> -->
                    <div class=" posre overflow zindex999 ">
                        <div class="w42p floatl">
                            <ul class="textr">
                                <transition name="moveLL">
                                    <li class="pt12 pb12" v-show="show1==1">
                                        <img class="w300" src="../../public/img/img206.png" alt="">
                                    </li>
                                </transition>
                                <transition name="moveLL">
                                    <li class="pt12 pb12" v-show="show2==1">
                                        <img class="w300" src="../../public/img/img207.png" alt="">
                                    </li>
                                </transition>
                                <transition name="moveLL">
                                    <li class="pt12 pb12" v-show="show3==1">
                                        <img class="w300" src="../../public/img/img208.png" alt="">
                                    </li>
                                </transition>
                                <transition name="moveLL">
                                    <li class="pt12 pb12" v-show="show4==1">
                                        <img class="w300" src="../../public/img/img209.png" alt="">
                                    </li>
                                </transition>
                            </ul>
                        </div>
                        <div class="w45p floatr">
                            <ul class="textl">
                                <transition name="moveRR">
                                    <li class="pt12 pb12" v-show="show5==1">
                                        <img class="w300" src="../../public/img/img210.png" alt="">
                                    </li>
                                </transition>
                                <transition name="moveRR">
                                    <li class="pt12 pb12" v-show="show6==1">
                                        <img class="w300" src="../../public/img/img211.png" alt="">
                                    </li>
                                </transition>
                                <transition name="moveRR">
                                    <li class="pt12 pb12" v-show="show7==1">
                                        <img class="w300" src="../../public/img/img212.png" alt="">
                                    </li>
                                </transition>
                                <transition name="moveRR">
                                    <li class="pt12 pb12" v-show="show8==1">
                                        <img class="w300" src="../../public/img/img213.png" alt="">
                                    </li>
                                </transition>
                            </ul>
                        </div>
                    </div>
                  
                </div>
            </div>
            <div class="w100p  pt15 pb55 textc">
                <span @click="open()" class="cursor bg1f8 cfff fs18 ml16 mr16 pt14 pb14 fbold  pl80 pr80 bradius8">立即咨询</span>
            </div>
        </div>

        <!-- <div class="posfix bgrg w100p h100p zindex999 pl10 pr10 overflow top0 left0" v-show="mask==1">
            <div class="posab left30p top30p bgfff w30p pt20 pb20 pl40 pr40 bradius8">
                <p class=" fbold fs20 c1f8 textc">立即咨询</p>
                <span @click="choose()" class="disinblock posab top0 right11 fs26 c333 cursor"> × </span>
                <div class="pt20 pb20">
                    <p class="posre bradius8 baee h40 alit mt20 mb20">
                        <span class="posab pr12 pl12 "><img class="w10 h14" src="../../public/img/img97.png"></span>
                        <input v-model="Name" class="textindent2 baee bradius8 w100p h100p borderno outline" type="text"
                            placeholder="请输入姓名...">
                    </p>
                    <p class="posre bradius8 baee h40 alit mt20 mb20">
                        <span class="posab  pr12 pl12 "><img class="w10 h14" src="../../public/img/img98.png"></span>
                        <input v-model="Phone" class="textindent2 baee bradius8 w100p h100p borderno outline" type="text"
                            placeholder="请输入手机号...">
                    </p>
                    <p @click="sentApply()" class=" h50 lh50 bradius8 cursor mt20 mb20 cfff bg1f8 textc fbold fs18 ">
                        确认提交
                    </p>
                </div>
            </div>
        </div> -->
        <Footer></Footer>
    </div>
</template>

<script>
    import Header from '@/components/Header'
    import Footer from '@/components/Footer'
    import $ from "jquery";
    export default {
        data() {
            return {
                show1: 0,
                show2: 0,
                show3: 0,
                show4: 0,
                show5: 0,
                show6: 0,
                show7: 0,
                show8: 0,
                color: 3,
                titleList: 1,
                link: 0,
                logo: 'school',
                bgImg: require('../../public/img/img300.png'),
                index: 0,
                mask: 0,
                Name: '',
                Phone: '',
                imgList: [
                    require('../../public/img/img222.png'),
                    require('../../public/img/img223.png'),
                    require('../../public/img/img224.png'),
                    require('../../public/img/img225.png'),
                    require('../../public/img/img226.png'),
                    require('../../public/img/img227.png'),
                ],
                imgList2: [
                    require('../../public/img/img228.png'),
                    require('../../public/img/img229.png'),
                    require('../../public/img/img230.png'),
                ],
                imgList3: [
                    require('../../public/img/img231.png'),
                    require('../../public/img/img232.png'),
                    require('../../public/img/img233.png'),
                ],
                isActive1: 0,
                isActive2: 0,
                isActive3: 0,
            };
        },
        components: {
            Header,
            Footer
        },
        methods: {
            activeIndex(id) {
                this.index = id
            },
            open() {
                this.mask = 1;
                $('body').css("overflow", "hidden")
            },
            choose() {
                this.mask = 0;
                $('body').css("overflow", "auto")
            },
            sentApply() {
                let that = this;
                if (that.Name == "" || !(/^1[23456789]\d{9}$/.test(that.Phone))) {
                    console.log(that.Name)
                    console.log(that.Phone)
                    alert('请正确输入');
                    return 0;
                } else {
                    $.ajax({
                        type: "POST",
                        url: that.beseSend + "recruitstudents/insterRecruitstudents.json",
                        dataType: "json",
                        async: false,
                        data: {
                            "name": that.Name,
                            "phone": that.Phone
                        },
                        success: function(data) {
                            alert(data.resultObj.info);
                            that.choose()
                        },
                        error: function(data) {
                            console.log(data);
                        }
                    });
                }
            },
            handleScroll() {
                const isElementNotInViewport = function(el) {
                    let rect = el.getBoundingClientRect();
                    return (
                        rect.top >= (window.innerHeight || document.documentElement.clientHeight) ||
                        rect.bottom <= 0
                    );
                };

                if (isElementNotInViewport(this.$refs.lightBtn)) {
                    this.show1 = 0;
                    this.show2 = 0;
                    this.show3 = 0;
                    this.show4 = 0;
                    this.show5 = 0;
                    this.show6 = 0;
                    this.show7 = 0;
                    this.show8 = 0;
                } else {
                    setTimeout(() => {
                        this.show1 = 1;
                        this.show5 = 1;
                    }, 100);
                    setTimeout(() => {
                        this.show2 = 1;
                        this.show6 = 1;
                    }, 200);
                    setTimeout(() => {
                        this.show3 = 1;
                        this.show7 = 1;
                    }, 300);
                    setTimeout(() => {
                        this.show4 = 1;
                        this.show8 = 1;
                    }, 400);
                }
            },
            Banner() {
                this.isActive1++;
                this.isActive2++;
                this.isActive3++;
                if (this.isActive1 > 5) {
                    this.isActive1 = 0
                }
                if (this.isActive2 > 2) {
                    this.isActive2 = 0
                }
                if (this.isActive3 > 2) {
                    this.isActive3 = 0
                }
            }
        },
        created() {

        },
        mounted() {
            this.$nextTick(() => {
                let timer;
                window.addEventListener("scroll", () => {
                    if (this.isFixed) {
                        this.isFixed = false;
                    }
                    if (timer) {
                        clearTimeout(timer);
                    }
                    timer = setTimeout(() => {
                        this.handleScroll();
                    }, 200);
                });
                this.handleScroll();
            });
            this.timer = setInterval(this.Banner, 2000);
        },
    }
</script>
<style scoped>
    .fade22-enter-active {
        transition: opacity 1s;
    }
    
    .fade22-enter,
    .fade22-leave-to {
        opacity: 0;
    }
    
    .bgrg {
        background: rgba(0, 0, 0, 0.5);
    }
    
    .bg138 {
        background-image: url('../../public/img/img138.png');
        background-size: 100%;
        color: #ff9211;
    }
    
    .bg139 {
        background-image: url('../../public/img/img139.png');
        background-size: 100%;
        color: #14d79e;
    }
    
    .bg140 {
        background-image: url('../../public/img/img140.png');
        background-size: 100%;
        color: #4850c7;
    }
    
    .bg141 {
        background-image: url('../../public/img/img141.png');
        background-size: 100%;
        color: #ff5353;
    }
    
    .bg142 {
        background-image: url('../../public/img/img142.png');
        background-size: 100%;
        color: #1f82f6;
    }
    
    .bg143 {
        background-image: url('../../public/img/img143.png');
        background-size: 100%;
        color: #ffc600;
    }
    
    .bg40 {
        background-image: url('../../public/img/img40.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
    }
    
    .moveLL-enter-active {
        transition: all 0.3s linear;
        transform: translateX(0%);
    }
    
    .moveLL-enter {
        transform: translateX(-100%);
    }
    
    .moveRR-enter-active {
        transition: all 0.3s linear;
        transform: translateX(0);
    }
    
    .moveRR-enter {
        transform: translateX(100%);
    }
</style>